<!--
Copyright 2023 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->
@if (selectedTeamId && teamList) {
  <div class="container">
    @if (myTeamIsSelected()) {
      <span class="mat-select right-text bold-text">Team:&nbsp;</span>
    }
    @if (!myTeamIsSelected()) {
      <span class="mat-select right-text bold-text">Observing:&nbsp;</span>
    }
    @if (teamList.length <= 1) {
      <span class="mat-select center-self">{{ getMyTeamShortName() }}</span>
    }
    @if (teamList.length > 1) {
      <mat-select class="center-self" placeholder="Team" [value]="selectedTeamId" (selectionChange)="setActiveTeam($event.value)">
        @for (team of teamList; track team.id) {
          <mat-option [value]="team.id">
            {{ team.shortName }}
          </mat-option>
        }
      </mat-select>
    }
  </div>
}
